export default __webpack_public_path__ + "static/media/safari.43cb3593.png";